var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"visible":_vm.viewIsReady,"title":_vm.title,"width":"1000px"},on:{"close":_vm.handleClose}},[_c('div',{staticStyle:{"line-height":"1.8"}},[_vm._v(" "+_vm._s(_vm.info)+" ")]),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.handleClose}},[_vm._v("确定")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }